export function SpecRow({
  headSizeCm,
  petalCount,
  stemsPerBunch,
  lengthSuffixCm,
  petalsUnit,
  stemsUnit,
}: {
  headSizeCm?: number;
  petalCount?: number;
  stemsPerBunch: number | null;
  lengthSuffixCm: string;
  petalsUnit: string;
  stemsUnit: string;
}) {
  if (headSizeCm === undefined || petalCount === undefined || stemsPerBunch === null) return null;
  return (
    <p
      data-testid="product-card-specs"
      data-head-size-cm={headSizeCm}
      data-petal-count={petalCount}
      data-stems-per-bunch={stemsPerBunch}
      className="text-[11px] leading-tight text-zinc-500"
    >
      {headSizeCm} {lengthSuffixCm} · {petalCount} {petalsUnit} ·{" "}
      {stemsPerBunch} {stemsUnit}
    </p>
  );
}
